import apiService from 'apiService'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'

// components

export default function CardEditStore() {
    const { id } = useParams()
    const [notAllowed, setNotAllowed] = useState('')
    const [reprint, setReprint] = useState(0)
    const [reprintBarrier, setReprintBarrier] = useState(0)
    const [reprintTargetAmount, setReprintTargetAmount] = useState(0)
    const [reprintWorkingHours, setReprintWorkingHours] = useState('')
    const [reprintPastHours, setReprintPastHours] = useState(0)
    const [reprintTimes, setReprintTimes] = useState(0)

    const [directly, setDirectly] = useState(0)
    const [directlyBarrier, setDirectlyBarrier] = useState(0)
    const [directlyTargetAmount, setDirectlyTargetAmount] = useState(0)
    const [directlyWorkingHours, setDirectlyWorkingHours] = useState('')

    const handleNotAllowedChange = e => setNotAllowed(e.target.value)
    const handleReprintChange = e => setReprint(e.target.value)
    const handleReprintBarrierChange = e => setReprintBarrier(e.target.value)
    const handleReprintTargetAmountChange = e => setReprintTargetAmount(e.target.value)
    const handleReprintWorkingHoursChange = e => setReprintWorkingHours(e.target.value)
    const handleReprintPastHours = e => setReprintPastHours(e.target.value)
    const handleReprintTimesChange = e => setReprintTimes(e.target.value)
    const handleDirectlyChange = e => setDirectly(e.target.value)
    const handleDirectlyBarrierChange = e => setDirectlyBarrier(e.target.value)
    const handleDirectlyTargetAmountChange = e => setDirectlyTargetAmount(e.target.value)
    const handleDirectlyWorkingHoursChange = e => setDirectlyWorkingHours(e.target.value)

    const getStoreParams = async () => {
        const response = await apiService.get(`/storeparameters/${id}`)
        const { not_allowed, reprint, reprint_barrier, reprint_target_amount, reprint_working_hours, reprint_past_hours, reprint_times, directly, directly_barrier, directly_target_amount, directly_working_hours } = response
        setNotAllowed(not_allowed)
        setReprint(reprint)
        setReprintBarrier(reprint_barrier)
        setReprintTargetAmount(reprint_target_amount)
        setReprintWorkingHours(reprint_working_hours)
        setReprintPastHours(reprint_past_hours)
        setReprintTimes(reprint_times)

        setDirectly(directly)
        setDirectlyBarrier(directly_barrier)
        setDirectlyTargetAmount(directly_target_amount)
        setDirectlyWorkingHours(directly_working_hours)
    }

    const handleChangeStoreParameters = async () => {
        const payload = {
            store_id: id,
            not_allowed: notAllowed,
            reprint: Number(reprint),
            reprint_barrier: parseFloat(reprintBarrier),
            reprint_target_amount: Number(reprintTargetAmount),
            reprint_working_hours: reprintWorkingHours,
            reprint_past_hours: parseFloat(reprintPastHours),
            reprint_times: Number(reprintTimes),
            directly: Number(directly),
            directly_barrier: parseFloat(directlyBarrier),
            directly_target_amount: Number(directlyTargetAmount),
            directly_working_hours: directlyWorkingHours
        }

        const response = await apiService.put(`/storeparameters/${id}`, payload)
        if (response === null) return
        toast.success('Επιτυχής επεξεργασία παραμέτρων!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
    }

    useEffect(() => {
        getStoreParams()
    }, [])
    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold">Παράμετροι Καταστήματος</h6>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                    <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase"></h6>

                    <div className="flex flex-wrap">
                        <div className="w-full lg:w-12/12 px-4">
                            <div className="relative w-full  mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΑΠΟΦΥΓΗ ΤΥΠΩΝ</label>
                                <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Αποφυγή τύπων" value={notAllowed} onChange={handleNotAllowedChange} />
                            </div>
                        </div>
                    </div>
                    <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">ΕΠΑΝΑΛΗΨΕΙΣ</h6>
                    <div className="flex flex-wrap">
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full  mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΕΝΕΡΓΟ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Ενεργή" value={reprint} onChange={handleReprintChange} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΚΑΤΩ ΟΡΙΟ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Κάτω Όριο" value={reprintBarrier} onChange={handleReprintBarrierChange} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΣΤΟΧΟΣ ΗΜΕΡΑΣ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Στόχος Ημέρας" value={reprintTargetAmount} onChange={handleReprintTargetAmountChange} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</label>
                                <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Ωράριο Λειτουργίας" value={reprintWorkingHours} onChange={handleReprintWorkingHoursChange} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΕΥΡΩΣ ΩΡΩΝ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Εύρως Ωρών" value={reprintPastHours} onChange={handleReprintPastHours} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΕΠΑΝΑΛΗΨΕΙΣ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Επαναλήψεις" value={reprintTimes} onChange={handleReprintTimesChange} />
                            </div>
                        </div>
                    </div>

                    <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">ΑΠΕΥΘΕΙΑΣ</h6>
                    <div className="flex flex-wrap">
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full  mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΕΝΕΡΓΟ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Ενεργό" value={directly} onChange={handleDirectlyChange} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΚΑΤΩ ΟΡΙΟ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Κάτω Όριο" value={directlyBarrier} onChange={handleDirectlyBarrierChange} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΣΤΟΧΟΣ ΗΜΕΡΑΣ</label>
                                <input type="number" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Στόχος Ημέρας" value={directlyTargetAmount} onChange={handleDirectlyTargetAmountChange} />
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</label>
                                <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Ωράριο Λειτουργίας" value={directlyWorkingHours} onChange={handleDirectlyWorkingHoursChange} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold"></h6>
                        <button className="bg-orange-500 text-white active:bg-orange-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" onClick={handleChangeStoreParameters}>
                            επεξεργασια παραμετρων
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
